import React from "react";
import "./DeleteRoleModal.css";

const DeleteRoleModal = ({ isOpen, onClose, onConfirm, role, deleting }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h3>Delete Role</h3>

        <p>
          Are you sure you want to delete{" "}
          <strong>{role?.roleName}</strong>?
        </p>

        <div className="modal-actions">
          <button
            className="btn-delete-modal cancel-modal-btn"
            onClick={onClose}
            disabled={deleting}
          >
            Cancel
          </button>

          <button
            className="btn-delete-modal delete-modal-btn"
            onClick={onConfirm}
            disabled={deleting}
          >
            {deleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteRoleModal;
